import React from 'react';
import { Container, Heading } from '../../shared';
export var SettingsPage = function () { return (React.createElement(Container, null,
    React.createElement(Heading, { level: "h1", title: "Settings" }))); };
